import React from 'react';
import Multiselect from 'react-select';

const FormMultiSelect = ({
  placeholder,
  options,
  onChangeVal,
  value,
  dispField,
  valField
}) => {
  const customMultiselect = {
    control: (styles, state) => ({
      ...styles,
      borderRadius: '6px',
      fontSize: '14px',
      height: '34px',
      minHeight: '34px',
      padding: '0 12px',
      background: `url(${require("App/assets/images/ic_arrow_down.png")}) calc(100% - 12px) / 16px no-repeat`,
      boxShadow: state.isFocused ? '0px 1px 1px rgba(0,0,0,0.075) inset,0px 1px 8px rgba(70,50,145,0.6)' : 'none',
      border: state.isFocused ? '1px solid rgba(70, 50, 145, 0.8)' : '1px solid #AFAFB9',
      outline: 'none',
      transition: '.2s',
      overflowY: 'scroll',
      overflowX: 'hidden',
      
      "&:hover": {
        border: state.isFocused ? '1px solid rgba(70, 50, 145, 0.8)' : '1px solid #AFAFB9',
      },

      "::-webkit-scrollbar": {
        display: "none"
      }
    }),

    valueContainer: (styles) => ({
      ...styles,
      padding: '0 20px 0 0',
      position: 'static'
    }),

    indicatorsContainer: () => ({
      display: 'none'
    }),

    menu: (styles) => ({
      ...styles,
      margin: '0',
      padding: '0',
      border: '1px solid #AFAFB9',
    }),

    menuList: (styles) => ({
      ...styles,
      padding: '4px 0',
    }),

    option: (styles) => ({
      ...styles,
      padding: '2px 8px',
      fontSize: '14px',
      backgroundColor: 'white',

      "&:hover": {
        backgroundColor: '#E6E6E6'
      },
    }),

    noOptionsMessage: (styles) => ({
      ...styles,
      padding: '2px 8px',
      fontSize: '14px',
    }),

    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#00B4A5',
      borderRadius: '4px',
      color: 'white',
      fontWeight: '600'
    }),

    multiValueLabel: (styles) => ({
      ...styles,
      color: 'white',
      fontWeight: '600'
    })
  };

  return (
    <Multiselect
      placeholder={placeholder ? placeholder : 'Select'}
      options={options}
      value={value}
      getOptionLabel={(option) => option[dispField]}
      getOptionValue={(option) => option[valField]}
      styles={customMultiselect}
      onChange={e => onChangeVal(e)}
      isMulti
    />
  );
}

export default FormMultiSelect;